import locale774e501e from '../../lang/fi.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"fi-fi","numberFormats":{"no-no":{"currency":{"style":"currency","currency":"NOK","currencyDisplay":"symbol","useGrouping":true}},"sv-se":{"currency":{"style":"currency","currency":"SEK","currencyDisplay":"symbol","useGrouping":true}},"en-gb":{"currency":{"style":"currency","currency":"GBP","currencyDisplay":"symbol","useGrouping":true}},"fi-fi":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol","useGrouping":true}},"int":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol","useGrouping":true}},"en-us":{"currency":{"style":"currency","currency":"USD","currencyDisplay":"symbol","useGrouping":true}}}},
  vueI18nLoader: false,
  locales: [{"code":"sv-se","label":"Sweden","file":"se.js","language":"sv","iso":"sv_SE","baseCountry":"Sweden","catalogId":"MoominProductCatalog","languageCode":"sv","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominSweden","merchantAccount":"MoominArabia-Sweden","baseStoreCode":"se","channelId":"moominarabia-sweden","appKey":"fiskarsmoominse","continent":"Europe","country":"Sweden","countryCode":"se"},{"code":"no-no","label":"Norwegian","file":"no.js","language":"no","iso":"no_NO","baseCountry":"Norway","catalogId":"MoominProductCatalog","languageCode":"no","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominNorway","merchantAccount":"MoominArabia-Norway","baseStoreCode":"no","channelId":"moominarabia-norwegian-1","appKey":"fiskarsmoominno","continent":"Europe","country":"Norway","countryCode":"no"},{"code":"en-gb","label":"English","file":"gb.js","iso":"en_GB","language":"en","baseCountry":"United Kingdom","catalogId":"MoominProductCatalog","languageCode":"en_GB","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominUK","merchantAccount":"MoominArabia-UK","baseStoreCode":"gb","channelId":"moominarabia-english-1","currency":"EUR","appKey":"fiskarsmoomingb","continent":"Europe","country":"United Kingdom","countryCode":"gb"},{"code":"fi-fi","label":"Finnish","file":"fi.js","language":"fi","iso":"fi_FI","baseCountry":"Finland","catalogId":"MoominProductCatalog","languageCode":"fi","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominFinland","merchantAccount":"MoominArabia-Finland","baseStoreCode":"fi","channelId":"moominarabia-finland","appKey":"fiskarsmoominfi","continent":"Europe","country":"Finland","countryCode":"fi"},{"code":"int","label":"Denmark","file":"en.js","language":"en","iso":"en_US","baseCountry":"Denmark","catalogId":"MoominProductCatalog","languageCode":"en","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominInternational","merchantAccount":"MoominArabia-Int","baseStoreCode":"dk","channelId":"moominarabia-international","currency":"EUR","appKey":"fiskarsmoominen","continent":"Europe","country":"Denmark","countryCode":"dk"},{"code":"int","label":"Poland","file":"en.js","language":"en","iso":"en_US","baseCountry":"Poland","catalogId":"MoominProductCatalog","languageCode":"en","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominInternational","merchantAccount":"MoominArabia-Int","baseStoreCode":"pl","channelId":"moominarabia-international","currency":"EUR","appKey":"fiskarsmoominen","continent":"Europe","country":"Poland","countryCode":"pl"},{"code":"int","label":"Germany","file":"en.js","language":"en","iso":"en_US","baseCountry":"Germany","catalogId":"MoominProductCatalog","languageCode":"en","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominInternational","merchantAccount":"MoominArabia-Int","baseStoreCode":"de","channelId":"moominarabia-international","currency":"EUR","appKey":"fiskarsmoominen","continent":"Europe","country":"Germany","countryCode":"de"},{"code":"en-us","label":"United States","file":"en.js","language":"en","iso":"en_US","baseCountry":"United States","catalogId":"MoominProductCatalog","languageCode":"en","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominUS","merchantAccount":"MoominArabia-US","baseStoreCode":"us","channelId":"moominarabia-us","appKey":"fiskarsmoominus","continent":"North America","country":"United States","countryCode":"us"}],
  defaultLocale: null,
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "lang/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://www.moominarabia.com",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  currency: "EUR",
  country: "fi",
  currencies: [{"name":"EUR","label":"Euro"},{"name":"NOK","label":"NOK"},{"name":"SEK","label":"SEK"},{"name":"GBP","label":"GBP"},{"name":"USD","label":"USD"}],
  seo: false,
  autoChangeCookie: {"currency":false,"locale":false,"country":false},
  normalizedLocales: [{"code":"sv-se","label":"Sweden","file":"se.js","language":"sv","iso":"sv_SE","baseCountry":"Sweden","catalogId":"MoominProductCatalog","languageCode":"sv","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominSweden","merchantAccount":"MoominArabia-Sweden","baseStoreCode":"se","channelId":"moominarabia-sweden","appKey":"fiskarsmoominse","continent":"Europe","country":"Sweden","countryCode":"se"},{"code":"no-no","label":"Norwegian","file":"no.js","language":"no","iso":"no_NO","baseCountry":"Norway","catalogId":"MoominProductCatalog","languageCode":"no","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominNorway","merchantAccount":"MoominArabia-Norway","baseStoreCode":"no","channelId":"moominarabia-norwegian-1","appKey":"fiskarsmoominno","continent":"Europe","country":"Norway","countryCode":"no"},{"code":"en-gb","label":"English","file":"gb.js","iso":"en_GB","language":"en","baseCountry":"United Kingdom","catalogId":"MoominProductCatalog","languageCode":"en_GB","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominUK","merchantAccount":"MoominArabia-UK","baseStoreCode":"gb","channelId":"moominarabia-english-1","currency":"EUR","appKey":"fiskarsmoomingb","continent":"Europe","country":"United Kingdom","countryCode":"gb"},{"code":"fi-fi","label":"Finnish","file":"fi.js","language":"fi","iso":"fi_FI","baseCountry":"Finland","catalogId":"MoominProductCatalog","languageCode":"fi","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominFinland","merchantAccount":"MoominArabia-Finland","baseStoreCode":"fi","channelId":"moominarabia-finland","appKey":"fiskarsmoominfi","continent":"Europe","country":"Finland","countryCode":"fi"},{"code":"int","label":"Denmark","file":"en.js","language":"en","iso":"en_US","baseCountry":"Denmark","catalogId":"MoominProductCatalog","languageCode":"en","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominInternational","merchantAccount":"MoominArabia-Int","baseStoreCode":"dk","channelId":"moominarabia-international","currency":"EUR","appKey":"fiskarsmoominen","continent":"Europe","country":"Denmark","countryCode":"dk"},{"code":"int","label":"Poland","file":"en.js","language":"en","iso":"en_US","baseCountry":"Poland","catalogId":"MoominProductCatalog","languageCode":"en","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominInternational","merchantAccount":"MoominArabia-Int","baseStoreCode":"pl","channelId":"moominarabia-international","currency":"EUR","appKey":"fiskarsmoominen","continent":"Europe","country":"Poland","countryCode":"pl"},{"code":"int","label":"Germany","file":"en.js","language":"en","iso":"en_US","baseCountry":"Germany","catalogId":"MoominProductCatalog","languageCode":"en","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominInternational","merchantAccount":"MoominArabia-Int","baseStoreCode":"de","channelId":"moominarabia-international","currency":"EUR","appKey":"fiskarsmoominen","continent":"Europe","country":"Germany","countryCode":"de"},{"code":"en-us","label":"United States","file":"en.js","language":"en","iso":"en_US","baseCountry":"United States","catalogId":"MoominProductCatalog","languageCode":"en","coveoSearchHub":"PROD_Moomin","baseStoreId":"MoominUS","merchantAccount":"MoominArabia-US","baseStoreCode":"us","channelId":"moominarabia-us","appKey":"fiskarsmoominus","continent":"North America","country":"United States","countryCode":"us"}],
  localeCodes: ["sv-se","no-no","en-gb","fi-fi","int","int","int","en-us"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "s",
  3: "e",
  4: ".",
  5: "j",
  6: "s",
  7: "\"",
  8: ":",
  9: "\"",
  10: ".",
  11: ".",
  12: "/",
  13: "l",
  14: "a",
  15: "n",
  16: "g",
  17: "/",
  18: "s",
  19: "e",
  20: ".",
  21: "j",
  22: "s",
  23: "\"",
  24: ",",
  25: "\"",
  26: "n",
  27: "o",
  28: ".",
  29: "j",
  30: "s",
  31: "\"",
  32: ":",
  33: "\"",
  34: ".",
  35: ".",
  36: "/",
  37: "l",
  38: "a",
  39: "n",
  40: "g",
  41: "/",
  42: "n",
  43: "o",
  44: ".",
  45: "j",
  46: "s",
  47: "\"",
  48: ",",
  49: "\"",
  50: "g",
  51: "b",
  52: ".",
  53: "j",
  54: "s",
  55: "\"",
  56: ":",
  57: "\"",
  58: ".",
  59: ".",
  60: "/",
  61: "l",
  62: "a",
  63: "n",
  64: "g",
  65: "/",
  66: "g",
  67: "b",
  68: ".",
  69: "j",
  70: "s",
  71: "\"",
  72: ",",
  73: "\"",
  74: "f",
  75: "i",
  76: ".",
  77: "j",
  78: "s",
  79: "\"",
  80: ":",
  81: "\"",
  82: ".",
  83: ".",
  84: "/",
  85: "l",
  86: "a",
  87: "n",
  88: "g",
  89: "/",
  90: "f",
  91: "i",
  92: ".",
  93: "j",
  94: "s",
  95: "\"",
  96: ",",
  97: "\"",
  98: "e",
  99: "n",
  100: ".",
  101: "j",
  102: "s",
  103: "\"",
  104: ":",
  105: "\"",
  106: ".",
  107: ".",
  108: "/",
  109: "l",
  110: "a",
  111: "n",
  112: "g",
  113: "/",
  114: "e",
  115: "n",
  116: ".",
  117: "j",
  118: "s",
  119: "\"",
  120: "}",
}

export const localeMessages = {
  'fi.js': () => Promise.resolve(locale774e501e),
  'se.js': () => import('../../lang/se.js' /* webpackChunkName: "lang-se.js" */),
  'no.js': () => import('../../lang/no.js' /* webpackChunkName: "lang-no.js" */),
  'gb.js': () => import('../../lang/gb.js' /* webpackChunkName: "lang-gb.js" */),
  'en.js': () => import('../../lang/en.js' /* webpackChunkName: "lang-en.js" */),
}
